import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  hostList: [],
};

const hostSlice = createSlice({
  name: "Host",
  initialState,
  reducers: {
    setHostList(state, action) {
      state.hostList = action.payload.hostList;
      return state;
    },
  },
});

export const hostAction = hostSlice.actions;

export default hostSlice;
